const USE_BFF = import.meta.env.VITE_USE_BFF !== "false";
const hasLiferay = typeof Liferay !== "undefined" && Liferay.ThemeDisplay;

const portalUrl = hasLiferay
  ? Liferay.ThemeDisplay.getPortalURL()
  : window.location.origin || "http://localhost:8080";

export const API_BASE_URL = USE_BFF
  ? `${portalUrl}/o/bff-api/proxy`
  : portalUrl;

export const API_ENDPOINTS = {
  GET_JOURNEY: "/o/restService/termJourney/getJourney",
  TERM_JOURNEY_GENERATE_OTP: "/o/restService/termJourney/generateOTP",
  TERM_JOURNEY_VERIFY_OTP: "/o/restService/termJourney/verifyOTP",
};

export const DEFAULT_ROUTE_MAP = {
  term: "/term-plan",
  nischit: "/retirement-plan",
  health: "/cancer-plan",
  tulip: "/combo-plan",
};

export const RESUME_DOB_SESSION_KEY = "rnlic_resumeDob";
export const getResumeDobStorageKey = (applicationNumber) =>
  `${RESUME_DOB_SESSION_KEY}:${String(applicationNumber || "").trim()}`;

export const getLegacyResumeJourneyUrl = () => {
  if (window.location.hostname.includes("websitedr")) {
    return "https://hrconnectsit.reliancenipponlife.com/DIGITERM/ApplicationRetrieval/RetrieveApplication";
  }

  return "https://onlinesales.indusindnipponlife.com/ApplicationRetrieval/RetrieveApplication";
};
